module.exports = __webpack_public_path__ + "img/floatright11.1028efe2.jpg";